import { Injectable } from '@angular/core';
import { FiCountdownNotificationService } from '../notification/countdown-notification/countdown-notification.service';
import { FiCountdownNotificationComponent } from '../notification/countdown-notification/countdown-notification.component';
import { AppTextService } from '@fi-shared/app-text';
import { IUpgradeLogEntry } from '@fi-shared/models';
import { FiTimeFormatOptions } from '@fi-shared/utils/format-date';
import { INotificationItem } from '@fi-app/utilities/notification/notification';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { FiAuthenticateSharedService } from '@fi-shared/fi-auth-shared/fi-authenticate-shared.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class FiUpgradeCountdownNotificationService {
    currentCountDown: INotificationItem = null;
    countDownDelayTimeout = null;

    constructor(
        private countdownNotificationService: FiCountdownNotificationService,
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
        private authenticateSharedService: FiAuthenticateSharedService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    private currentUpgradeLogEntry: IUpgradeLogEntry;
    StartUpgradeCountDown(upgradeLogEntry: IUpgradeLogEntry) {
        const UpgradeTimeLeft = upgradeLogEntry.SecondsUntilUpgradeStart * 1000;

        if (
            this.currentUpgradeLogEntry &&
            this.currentUpgradeLogEntry.Id == upgradeLogEntry.Id &&
            this.currentUpgradeLogEntry.UpgradeOn == upgradeLogEntry.UpgradeOn &&
            this.currentUpgradeLogEntry.UpgradeEndTime == upgradeLogEntry.UpgradeEndTime
        )
            return false;

        if (UpgradeTimeLeft <= 0) {
            return false;
        }

        if (this.currentCountDown) {
            this.CancelUpgradeCountDown();
        }

        this.currentUpgradeLogEntry = upgradeLogEntry;

        let countDownStartDelay = UpgradeTimeLeft - FiAppSettings.CountDownTime;
        if (countDownStartDelay < 0) {
            countDownStartDelay = 0;
        } else if (countDownStartDelay > 7 * 24 * 60 * 60 * 1000) {
            // do not start upgrade counter if upgrade mo then one week further
            return false;
        }

        this.countDownDelayTimeout = setTimeout(() => {
            const updateEnd = upgradeLogEntry.UpgradeEndTime;

            this.currentCountDown = this.countdownNotificationService.StartCountDown(
                {
                    countDownTime: UpgradeTimeLeft - countDownStartDelay,
                    countDownTitle: this.appTextService.get('upgrade.upgrade_countdown'),
                    countDownText: this.appTextService.get('upgrade.time_until_upgrade'),
                },
                FiCountdownNotificationComponent,
            );

            this.currentCountDown.countdownFinished.subscribe(() => {
                this.authenticateSharedService.logout();
            });

            if (countDownStartDelay > 0) {
                this.fiDialogsService.notify({
                    messageText:
                        String.format(this.appTextService.get('upgrade.will_be_upgraded'), 2) +
                        '<br/><br/>' +
                        this.appTextService.get('upgrade.you_will_be_logged_out') +
                        ' ' +
                        String.format(
                            this.appTextService.get('upgrade.to_be_completed'),
                            '',
                            this.fiFormatDateService.formatDate(new Date(updateEnd), FiTimeFormatOptions),
                        ),
                });
            }
        }, countDownStartDelay);
    }

    CancelUpgradeCountDown() {
        this.currentUpgradeLogEntry = null;
        if (this.countDownDelayTimeout) {
            clearTimeout(this.countDownDelayTimeout);
        }

        if (this.currentCountDown) {
            this.currentCountDown.HideNotification();
            this.currentCountDown = null;
        }
    }
}
